import React, { useState, useEffect, useCallback } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  Col,
  Row,
  Form,
  Modal,
  InputGroup,
  FormControl,
  Badge,
  FormSelect,
  // Container,
} from "@themesberg/react-bootstrap";
import { Button, Label, Spinner } from "reactstrap";
import CustomInput from "../CustomInput";
import { useSelector } from "react-redux";
import {
  faEye,
  faEyeSlash,
  // faTrash,
  faUserAlt,
} from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-hot-toast";
import { _fetchApi, _postApi } from "../../../redux/action/api";
import { SearchBar } from "../../../components/UI";
import { taxStations } from "../../../utils/tax-stations";
import validator from "validator";
import CustomTypeahead from "../../../components/UI/CustomTypeahead";
import { Checkbox, setRef } from "@material-ui/core";
import { Typeahead } from "react-bootstrap-typeahead";
import "./admin-mngr.css";
import { PREVILLAGES } from "../../../redux/action/type";
import { isSuper } from "../../../components/UI/helpers";

export default () => {
  const { user } = useSelector((s) => s.auth);
  const _form = {
    account_type: "admin",
    name: "", // Individual's full name
    phone: "", // Individual's phone number
    email: "",
    role: "admin", // Individual's nin
    state: "Kano", // Individual's state
    lga: "", // Individual's local government
    org_name: "", // Organization's name
    password: "123456",
    accessTo: "",
    mda_code: "", // on submit is "" set auth mda_code
    mda_name: user.mda_name || "",
    rank: "",
    department: "",
    sector: "",
  };
  const [form, setForm] = useState(_form);
  const [errors, setErrors] = useState({
    department: "",
    name: "",
    phone: "",
    email: "",
    accessTo: "",
    rank: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showDefault, setShowDefault] = useState(false);
  const toggle = () => {
    setForm(_form)
    setShowDefault(!showDefault);
  }
  const [filterText, setFilterText] = useState("");
  const [admins, setAdmins] = useState([]);
  const [adminList, setAdminList] = useState([]);
  const [mdaDepts, setMdaDepts] = useState([]);
  const [mdas, setMdas] = useState([]);

  const ACCESS_OPTIONS = isSuper(user)? PREVILLAGES.split(","): user?.accessTo?.split(",");

  const handleCheckAll = ()=>{
    if(form.accessTo.split(',').length > 1){
      setForm((prevState) => ({...prevState, accessTo: ''}))
    }else{
    setForm((prevState) => ({...prevState, accessTo: ACCESS_OPTIONS.toString()}))
    }
  }

  const handleChange = ({ target: { name, value } }) => {
    if (name === "accessTo") {
      setForm((prevState) => {
        if (prevState.accessTo?.split(',')?.includes(value)) {
          return {
            ...prevState,
            accessTo: prevState.accessTo?.split(',').filter((item) => item !== value).toString(),
          };
        } else {
          return {
            ...prevState,
            accessTo: `${prevState.accessTo},${value}`,
          };
        }
      });
    } else {
      setForm((prevState) => ({ ...prevState, [name]: value }));
    }
  };

  const getMDAs = useCallback(() => {
    _fetchApi("/get/mdas", (resp) => {
      setMdas(resp.data);
    });
  }, []);

  const getMDADepts = useCallback(() => {
    _fetchApi(
      `/get/mda-departments?mda_code=${
        form.mda_code ? form.mda_code : user.mda_code
      }`,
      (resp) => {
        if (resp.success) {
          setMdaDepts(resp.data);
        }
      },
      (err) => {
        console.error(err);
      }
    );
  }, [user.mda_code, form.mda_code]);

  const getAdmins = useCallback(() => {
    _fetchApi(
      `/users/get-admins?mda_code=${user.mda_code || ""}`,
      (resp) => {
        if (resp.success) {
          setAdmins(resp.data);
        } else {
          setAdmins([]);
        }
      },
      () => {
        setAdmins([]);
        // toast.error("Error: Failed to submit");
      }
    );
  });

  const getDepartment = () => {
    _postApi(
      "/add-departments",
      {},
      () => {},
      () => {}
    );
  };
  useEffect(() => {
    getAdmins();
    getMDAs();
    getMDADepts();
  }, [getMDADepts]);

  const handleSubmit = () => {
    setLoading(true);
    const handleResponse = (result, indx = null, total = null) => {
      if (result.success && (indx === total - 1 || total === null)) {
        toast.success("Submitted");
        getAdmins();
        setForm(_form);
        setAdminList([]);
        setShowDefault(false); // Hide the modal
      } else if (!result.success) {
        toast.error(result.msg);
      }
      setLoading(false);
    };
  
    if (adminList.length) {
      adminList.forEach((admin, indx) => {
        setTimeout(() => {
          _postApi(
            "/auths/-post-users",
            {
              ...admin,
              mda_code: admin.mda_code ? admin.mda_code : user.mda_code,
              accessTo: admin?.accessTo.toString(),
              query_type: "create-admin",
            },
            (result) => handleResponse(result, indx, adminList.length),
            (err) => {
              toast.error(err.msg);
              setLoading(false);
            }
          );
        }, 300);
      });
    } else {
      _postApi(
        "/auths/-post-users",
        {
          ...form,
          mda_code: form.mda_code ? form.mda_code : user.mda_code,
          accessTo: form.accessTo.toString(),
          query_type: form.id ? "update-admin" : "create-admin",
          user_id: form.id ? form.id : "",
        },
        (result) => handleResponse(result),
        (err) => {
          toast.error(err.msg);
          setLoading(false);
        }
      );
    }
  };

  const toggleShowPassword = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };

  const addAdmin = (e) => {
    e.preventDefault();
    const error = {};
    if (!form.name) {
      error.name = "Admin name is required";
    } else {
      error.name = "";
    }
    if (
      !validator.isNumeric(form.phone) ||
      !validator.isLength(form.phone, { min: 11, max: 11 })
    ) {
      error.phone = "Enter a valid 11-digit phone number";
    } else {
      error.phone = "";
    }
    setErrors(error);
    if (
      // error.department === "" &&
      error.name === "" &&
      error.phone === ""
    ) {
      setAdminList((p) => [...p, form]);

      setForm({ ..._form, mda_name: form.mda_name, mda_code: form.mda_code });
    }
  };

  const updateUser = (user_status, message) => {
    _postApi(
      "/auths/-post-users",
      {
        user_status: user_status,
        query_type: "update_status",
      },
      () => {
        toast.success(message);
        getAdmins();
      },
      (err) => {
        toast.error(err.msg);
      }
    );
  };

  const filtered_data = admins?.filter(
    (item) =>
      item?.name?.toLowerCase()?.includes(filterText.toLowerCase()) ||
      item?.phone.toString()?.includes(filterText)
  );

  return (
    <div
      style={{
        height: "90vh",
        overflowY: "scroll",
        scrollbarWidth: "thin", // For Firefox
        scrollbarColor: "transparent transparent", // For Firefox
        overflow: "-moz-scrollbars-none",
      }}
    >
      <Modal as={Modal.Dialog} centered show={showDefault} size="lg">
        <Modal.Header>
          <Modal.Title className="h6">Admin/Agent Form</Modal.Title>
          <Button className="bg-danger" aria-label="Close" onClick={toggle}>
            X
          </Button>
        </Modal.Header>
        <Modal.Body>
          {/* {JSON.stringify(form)} */}
          <Form className="mt-4">
            <Row>
              <Col md={4}>
                <CustomInput
                  label="Contact Full name"
                  onChange={handleChange}
                  type="text"
                  name="name"
                  value={form.name}
                />

                <span className="text-danger">
                  {errors.name ? errors.name : null}
                </span>
              </Col>
              <Col md={4} className="mb-1">
                <CustomInput
                  label="Contact Phone No."
                  type="text"
                  name="phone"
                  value={form.phone}
                  onChange={handleChange}
                />

                <span className="text-danger mt--2">
                  {errors.phone ? errors.phone : null}
                </span>
              </Col>
              <Col md={4} className="mb-1">
                <CustomInput
                  label="Contact Email"
                  type="email"
                  name="email"
                  value={form.email}
                  onChange={handleChange}
                />

                <span className="text-danger">
                  {errors.email ? errors.email : null}
                </span>
              </Col>
              <Col md={4} className="mb-1">
                <Label>Role</Label>
                <FormSelect
                  label="Role"
                  type="role"
                  name="role"
                  value={form.role}
                  onChange={handleChange}
                >
                  <option value={"admin"}>Admin</option>
                  <option value={"agent"}>Agent</option>
                 {['Super Admin','Developer'].includes(user?.role)? <option value={"Super Admin"}>Super Admin</option>:""}
                </FormSelect>
              </Col>
              {user?.mda_code ? null : (
                <Col md={4} className="mb-1">
                  <CustomTypeahead
                    label="MDA"
                    onInputChange={(e) => {}}
                    // multiple
                    onChange={(s) => {
                      setForm((p) => ({
                        ...p,
                        mda_code: s[0]?.mda_code,
                        mda_name: s[0]?.mda_name,
                        sector: s[0]?.sector,
                      }));
                    }}
                    labelKey={(a) => `${a?.mda_name}`}
                    options={mdas}
                    clearButton
                    col={12}
                  />
                </Col>
              )}
              {user.mda_code || form.mda_code ? (
                <Col md={4} className="mb-1">
                  <Label>Department</Label>
                  <FormSelect
                    type="select"
                    name="department"
                    value={form.department}
                    required="required"
                    onChange={handleChange}
                  >
                    <option value={""}>Select department</option>
                    {mdaDepts.map((dept, idx) => (
                      <option key={idx}>{dept.title}</option>
                    ))}
                  </FormSelect>
                  <span className="text-danger">
                    {errors.department ? errors.department : null}
                  </span>
                </Col>
              ) : null}

              <Col md={4} className="mb-4">
                <Form.Label>Rank</Form.Label>
                <FormSelect
                  label="Rank"
                  type="rank"
                  name="rank"
                  value={form.rank}
                  onChange={handleChange}
                >
                  <option value={""}>Select Rank</option>
                  <option value={"Department Head"}>Department Head</option>
                  <option value={"Staff"}>Staff</option>
                  <option value={"Directors Account"}>Directors Account</option>
                </FormSelect>
              </Col>
              <Col md={4} className="mb-1">
                <CustomTypeahead
                  label="Sector"
                  multiple
                  onInputChange={() => {}}
                  onChange={(s) => {
                    setForm((p) => ({
                      ...p,
                      sector: s.join(","),
                    }));
                  }}
                  // labelKey={"mda_name"}
                  options={["TAX", "NON TAX", "LAND", "LGA", "VEHICLES"]}
                  col={12}
                />
              </Col>
              <Col md={4} className="mb-1">
                <Label>Tax Station</Label>
                <Typeahead
                  id="station"
                  placeholder="Tax Station"
                  name="tax_station"
                  options={taxStations}
                  value={form.tax_station}
                  onChange={(selected) => {
                    setForm((p) => ({
                      ...p,
                      tax_station: selected,
                    }));
                  }}
                />
              </Col>
              <Col md={4} className="mb-4">
                <Form.Label>Password</Form.Label>
                <InputGroup>
                  <FormControl
                    type={showPassword ? "text" : "password"}
                    name="password"
                    value={form.password}
                    onChange={handleChange}
                    placeholder="Password"
                  />
                  <InputGroup.Text
                    style={{ cursor: "pointer" }}
                    onClick={toggleShowPassword}
                  >
                    <FontAwesomeIcon icon={showPassword ? faEye : faEyeSlash} />
                  </InputGroup.Text>
                </InputGroup>
              </Col>

              {form.role === "admin" ? (
                <Col md={12} className="mb-1">
                  <Label>Access to </Label>{" "}
                  <Label htmlFor={`access-x`}>
                    ( All
                    <Checkbox
                      id={`access-x`}
                      name="accessTo"
                      onChange={handleCheckAll}
                      value={form.accessTo}
                      checked={
                        form?.accessTo?.split(',')?.length >= ACCESS_OPTIONS?.length
                      }
                    />
                    )
                  </Label>
                  <div className="row">
                    {ACCESS_OPTIONS?.map((item, idx) => (
                      <div className="col-md-4" key={idx}>
                        <Label
                          htmlFor={`access-${idx}`}
                          className="checkbox-label"
                        >
                          <Checkbox
                            id={`access-${idx}`}
                            name="accessTo"
                            onChange={handleChange}
                            value={item}
                            checked={form.accessTo?.split(',')?.includes(item)}
                          />{" "}
                          {item}
                        </Label>
                      </div>
                    ))}
                  </div>
                  <span className="text-danger">
                    {errors.accessTo ? errors.accessTo : null}
                  </span>
                </Col>
              ) : null}
              {/*user?.mda_code===null :  Admin is super admin: Admin is belong to one MDA (the mda_code hes bearing) */}

              {/* <Col md={12} className="text-center">
                {" "}
                <Button onClick={handleSubmit} color="dark" className="ms-auto">
                  {loading ? <Spinner /> : "Submit"}
                </Button>
              </Col> */}
              <Col md={6} className="text-center">
                <br />
              </Col>
            </Row>
          </Form>

          <table>
            {adminList?.length ? (
              <thead>
                <tr>
                  <th>SN</th>
                  <th>NAME</th>
                  <th>PHONE</th>
                  <th>EMAIL</th>
                  <th>ROLE</th>
                  <th>MDA</th>
                  <th>DEPARTMENT</th>
                  <th>ACTION</th>
                </tr>
              </thead>
            ) : null}
            <tbody>
              {adminList?.map((admin, idx) => (
                <tr key={idx}>
                  <td>{idx + 1}</td>
                  <td>{admin.name}</td>
                  <td>{admin.phone}</td>
                  <td>{admin.email}</td>
                  <td>{admin.role}</td>
                  <td>{admin.mda}</td>
                  <td>{admin.department}</td>
                  <td>
                    <Button
                      color="light"
                      size="sm"
                      onClick={() => {
                        setForm((p) => ({ ...p, ...admin }));
                        setShowDefault(true);
                      }}
                    >
                      EDIT
                    </Button>
                    <Button size="sm" color="warning">
                      Delete
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </Modal.Body>
        <hr />
        <Row className="m-3">
        {form.id ?"": <Col md={6} className="text-center">
            <Button onClick={addAdmin} color="dark" className="ms-auto">
              {loading ? <Spinner /> : "Add to list"}
            </Button>
          </Col>}
          <Col className="text-center">
  <Button onClick={handleSubmit} color="dark" className="ms-auto">
    {loading ? <Spinner /> : "Submit"}
  </Button>
</Col>
        </Row>
      </Modal>
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-3">
        <div className="d-block mb-4 mb-md-0">
          <h4>Admin list</h4>
          {/* {JSON.stringify(form)} */}
          <p className="mb-0">{user.mda_name}.</p>
        </div>
        <div className="btn-toolbar mb-2 mb-md-0">
          <Button variant="outline-primary" size="sm" onClick={toggle}>
            Create Admin{" "}
            <FontAwesomeIcon icon={faUserAlt} size="lg" className="me-2" />
          </Button>
        </div>
      </div>
      {/* {JSON.stringify(admins)} */}
      <div className="table-settings mb-4">
        <Row className="justify-content-between align-items-center">
          <Col md={10}>
            <SearchBar
              filterText={filterText}
              onFilterTextChange={(val) => setFilterText(val)}
            />
          </Col>
          <Col md={2}>
            <Badge>{admins?.length}</Badge>
          </Col>
        </Row>
      </div>
      <div style={{ height: "70vh", minHeight: "50vh", overflowY: "scroll" }}>
        <table striped>
          <thead>
            <tr>
              <th>SN@</th>
              <th>NAME</th>
              <th>PHONE</th>
              <th>EMAIL</th>
              <th>ROLE</th>
              <th>MDA</th>
              <th>DEPARTMENT</th>
              <th>RANK</th>
              <th style={{ width: "15%" }}>ACTION</th>
            </tr>
          </thead>
          <tbody>
            {filtered_data?.map((admin, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{admin.name}</td>
                <td>{admin.phone}</td>
                <td>{admin.email}</td>
                <td>{admin.role}</td>
                <td>{admin.mda}</td>
                <td>{admin.department}</td>
                <td>{admin.rank}</td>
                <td>
                  <Button
                    color="secondary"
                    size="sm"
                    outline
                    onClick={() => {
                      setForm((p) => ({ ...p, ...admin }));
                      setShowDefault(true);
                    }}
                  >
                    EDIT
                  </Button>
                  {admin.status === "suspended" ? (
                    <Button
                      outline
                      size="sm"
                      color="danger"
                      onClick={() =>
                        updateUser("approved", "Suspended successfully")
                      }
                    >
                      Revert
                    </Button>
                  ) : (
                    <Button
                      outline
                      size="sm"
                      color="warning"
                      onClick={() =>
                        updateUser("approved", "Approved successfully")
                      }
                    >
                      Suspend
                    </Button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {/* List of Admins */}
    </div>
  );
};
